/* Small, event-driven enhancements. Essential content is always server-rendered. */
(() => {
  if (window.bicaInteractionsReady) return;
  window.bicaInteractionsReady = true;
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  let observer;
  const targets = '.bica-heading-row,.bica-intro,.bica-category,.bica-product-card,.bica-editorial-card,.bica-story-copy,.bica-lab-recipe,.bica-disclosure,.bica-passport-mark,.bica-editorial-head,.bica-curation-card,.bica-manifesto-inner,.bica-ritual-copy,.bica-compare-card,.product__info-container,.bica-lab-output';
  const motionEnabled = () => document.documentElement.dataset.bicaMotion !== 'none' && !reduced.matches && !window.Shopify?.designMode;

  function observe(root = document) {
    if (!motionEnabled() || !('IntersectionObserver' in window)) return;
    observer ??= new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);
        // Animate once, only if the visitor has not disabled motion in the meantime.
        if (motionEnabled() && !entry.target.closest('[hidden]')) entry.target.classList.add('bica-enter');
      });
    }, { threshold: 0.08 });
    root.querySelectorAll(targets).forEach((element, index) => {
      if (element.dataset.bicaObserved) return;
      element.dataset.bicaObserved = 'true';
      // Never delay first-viewport content or the hero/LCP image.
      if (element.getBoundingClientRect().top < window.innerHeight) return;
      element.style.setProperty('--bica-stagger', `${Math.min(index % 3, 2) * 55}ms`);
      observer.observe(element);
    });
  }
  observe();
  document.addEventListener('shopify:section:load', event => observe(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll(targets).forEach(element => observer?.unobserve(element));
    if (opener && event.target.contains(opener)) dialog?.close();
  });
  reduced.addEventListener?.('change', () => {
    if (reduced.matches) {
      observer?.disconnect();
      document.querySelectorAll('.bica-enter').forEach(element => element.classList.remove('bica-enter'));
    }
  });

  let dialog;
  let opener;
  function openPreview(trigger, template) {
    if (!dialog) {
      dialog = document.createElement('dialog');
      dialog.className = 'bica-preview-dialog bica-experience color-scheme-1';
      dialog.setAttribute('aria-labelledby', 'BicaPreviewTitle');
      dialog.addEventListener('click', event => {
        if (event.target.closest('[data-preview-close]')) dialog.close();
        else if (event.target === dialog) {
          const box = dialog.getBoundingClientRect();
          if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
        }
      });
      dialog.addEventListener('close', () => {
        document.documentElement.classList.remove('bica-preview-open');
        if (opener?.isConnected) opener.focus({ preventScroll: true });
        dialog.replaceChildren();
      });
      document.body.append(dialog);
    }
    opener = trigger;
    dialog.replaceChildren(template.content.cloneNode(true));
    dialog.querySelector('[data-preview-title]').id = 'BicaPreviewTitle';
    document.documentElement.classList.add('bica-preview-open');
    dialog.showModal();
    dialog.querySelector('[data-preview-close]').focus({ preventScroll: true });
  }
  if (!customElements.get('bica-preview')) customElements.define('bica-preview', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      if (typeof HTMLDialogElement === 'undefined' || !HTMLDialogElement.prototype.showModal) return;
      const button = this.querySelector('button');
      const template = this.querySelector('template');
      if (!button || !template) return;
      button.hidden = false;
      button.addEventListener('click', () => openPreview(button, template), { signal: this.abort.signal });
    }
    disconnectedCallback() {
      this.abort?.abort();
      if (this.contains(opener)) dialog?.close();
    }
  });
})();
